/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum LifeCycleStage {
    Active = 'Active',
    PendingDeletion = 'PendingDeletion'
}


export function LifeCycleStageFromJSON(json: any): LifeCycleStage {
    return LifeCycleStageFromJSONTyped(json, false);
}

export function LifeCycleStageFromJSONTyped(json: any, ignoreDiscriminator: boolean): LifeCycleStage {
    return json as LifeCycleStage;
}

export function LifeCycleStageToJSON(value?: LifeCycleStage | null): any {
    return value as any;
}

